import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import { magazineArticleEditFragment } from '../../fragments/MagazineArticleEdit.fragment'

import type {
    MagazineArticleEditQuery,
    MagazineArticleEditQueryVariables,
} from './Edit.queries.generated'

export const GET_ARTICLE_EDIT = gql`
    query MagazineArticleEdit($containerGuid: String!, $guid: String!) {
        site {
            guid
            maxCharactersInAbstract
        }
        viewer {
            guid
            canInsertMedia(subtype: "blog")
        }
        container: entity(guid: $containerGuid) {
            guid
            ... on MagazineIssue {
                url
                canEdit
            }
        }
        entity(guid: $guid) {
            guid
            ...MagazineArticleEdit
        }
    }
    ${magazineArticleEditFragment}
` as TypedDocumentNode<
    MagazineArticleEditQuery,
    MagazineArticleEditQueryVariables
>
